/**
 * The amount a customer pays for an order: items + delivery fee − discount.
 *
 * It is what checkout shows as "To Pay", what an online payment charges, what
 * a rider collects for cash-on-delivery, and what cash reports reconcile
 * against. `total_amount` is only the items subtotal.
 *
 * Mirrors the backend's pricing.order_payable: the server-stored
 * payable_amount when present; otherwise (orders from before server-side
 * pricing, subscription orders) derived from the stored parts — which for
 * those is simply total_amount, as they always showed.
 */
const num = (value) => {
  const n = Number(value);
  return Number.isFinite(n) ? n : 0;
};

export const orderPayable = (order) => {
  if (!order) return 0;
  if (order.payable_amount !== null && order.payable_amount !== undefined) return num(order.payable_amount);
  const payable = Math.max(0, (num(order.total_amount) + num(order.delivery_fee)) - num(order.coupon_discount));
  return Math.round(payable * 100) / 100;
};

/**
 * What cancelling would refund — the amount actually paid, so nothing for an
 * unpaid order (COD not yet collected, online still awaiting payment). The
 * server computes the authoritative figure when the order is cancelled.
 */
export const orderRefundPreview = (order) => (order?.payment_status === 'paid' ? orderPayable(order) : 0);
